import React from 'react';
import Icon from '../AppIcon';

const Button = ({ 
  children, 
  variant = 'default',
  size = 'default',
  disabled = false,
  loading = false,
  icon,
  iconName,
  iconPosition = 'left',
  className = '',
  onClick,
  type = 'button',
  ...props 
}) => {
  // Base button classes
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  // Variant classes
  const variantClasses = {
    default: 'bg-primary text-primary-foreground hover:bg-primary/90 focus:ring-primary',
    primary: 'bg-primary text-primary-foreground hover:bg-primary/90 focus:ring-primary',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80 focus:ring-secondary',
    destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 focus:ring-destructive',
    outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground focus:ring-ring',
    ghost: 'hover:bg-accent hover:text-accent-foreground focus:ring-ring',
    link: 'text-primary underline-offset-4 hover:underline focus:ring-primary'
  };

  // Size classes
  const sizeClasses = {
    sm: 'h-9 px-3 text-sm',
    default: 'h-10 px-4 py-2',
    lg: 'h-11 px-8',
    icon: 'h-10 w-10'
  };

  // Combine classes
  const buttonClasses = `
    ${baseClasses}
    ${variantClasses?.[variant] || variantClasses?.default}
    ${sizeClasses?.[size] || sizeClasses?.default}
    ${className}
  `?.trim()?.replace(/\s+/g, ' ');

  // Handle icon rendering
  const renderIcon = () => {
    if (loading) {
      return <Icon name="Loader2" className="w-4 h-4 animate-spin" />;
    }
    
    if (icon) {
      return icon;
    }
    
    if (iconName) {
      return <Icon name={iconName} className="w-4 h-4" />;
    }
    
    return null;
  };

  const iconElement = renderIcon();

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {iconElement && iconPosition === 'left' && (
        <span className={children ? 'mr-2' : ''}>{iconElement}</span>
      )}
      {children}
      {iconElement && iconPosition === 'right' && (
        <span className={children ? 'ml-2' : ''}>{iconElement}</span>
      )}
    </button>
  );
};

export default Button;